//Receipt Listing
export const FETCH_JEWELRY_RECEIPT_LISTING_SUCCESS = 'FETCH_JEWELRY_RECEIPT_LISTING_SUCCESS';
export const FETCH_JEWELRY_RECEIPT_LISTING_FAILURE = 'FETCH_JEWELRY_RECEIPT_LISTING_FAILURE';
export const UPDATE_JEWELRY_RECEIPT_DATA_AFTER_UPDATE = 'UPDATE_JEWELRY_RECEIPT_DATA_AFTER_UPDATE';
export const SAVE_JEWELRY_RECEIPT_FORM_DETAILS = 'SAVE_JEWELRY_RECEIPT_FORM_DETAILS';
export const SAVE_ITEMS_DETAILS_IN_JEWELRY_FORM = 'SAVE_ITEMS_DETAILS_IN_JEWELRY_FORM';
export const RESET_SAVE_JEWELRY_RECEIPT_DETAILS = 'RESET_SAVE_JEWELRY_RECEIPT_DETAILS';

export const RESET = 'RESET';
